import { Link } from "react-router-dom";
import type { MoneyStep } from "../../api/dashboard";
import { formatMoney } from "../../api/money";
import { Card } from "../../components/ui";

/** The contract's money at the four places it waits. Priced by the server
 * from the documents' own totals; this only formats what arrives. */
export function CommercialCard({ steps }: { steps: MoneyStep[] }) {
  return (
    <Card
      className="dash-card"
      title="Commercial"
      sub="excluding VAT"
      actions={
        <Link className="go-link" to="/commercial">
          Open Commercial →
        </Link>
      }
    >
      <dl className="money-tiles">
        {steps.map((step) => (
          <div key={step.key} className="money-tile">
            <dt>{step.label}</dt>
            <dd className="money-amount">{formatMoney(step.amount)}</dd>
            <dd className="money-count">
              {step.count} {step.noun}
              {step.count === 1 ? "" : "s"}
            </dd>
          </div>
        ))}
      </dl>
    </Card>
  );
}
